/**
 * CZNA-1614 — "open at source" link next to a 024 `$a` identifier.
 *
 * A cataloguer checks an identifier (VIAF, ISNI, ORCID, Wikidata…) at its
 * source with one click (UC AR-18). The URL comes from the `uriTemplate` of the
 * sibling URI subfield (`$1`, matched the same way `fillUriFromIdentifier` does:
 * the first OTHER subfield of the group carrying one) and the LIVE `$a` value —
 * not from the stored `$1`, which may have been picked from another host or not
 * be filled until `$a` loses focus. Renders nothing when the group has no
 * template, `$a` is empty, or the result is not an `http(s)` URL
 * (`buildSourceUrl`).
 *
 * Drawn inside the `$a` input box at its right end (`inputAdornment` of
 * `SubfieldInput`, the same box in `ExternalIdentifierLookupSubfield`): the
 * actions slot beside the input holds two icon buttons, and the lookup row
 * already fills it with ✕ and the search button.
 *
 * A plain `<a>` rather than Stripes' `IconButton href`: that one renders a
 * react-router `Link`, which treats the URL as an in-app route.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from '@folio/stripes/components';
import buildSourceUrl from '../utils/buildSourceUrl';
// Fits the room the input reserves for it (`subfieldInputAdornedStyle`).
var linkStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '4px',
    color: '#1960a4',
};
var OpenAtSourceLink = function (_a) {
    var code = _a.code, identifier = _a.identifier, siblingSubfields = _a.siblingSubfields, sourceLabel = _a.sourceLabel;
    var intl = useIntl();
    var uriSubfield = siblingSubfields.find(function (s) { return s.code !== code && !!s.uriTemplate; });
    var href = uriSubfield ? buildSourceUrl(uriSubfield.uriTemplate, identifier) : null;
    if (!href)
        return null;
    var source = (sourceLabel === null || sourceLabel === void 0 ? void 0 : sourceLabel.trim()) || new URL(href).hostname;
    var name = intl.formatMessage({ id: 'ui-czna-authorities.externalIdentifier.openAtSource' }, { source: source });
    return (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer", "aria-label": name, title: name, style: linkStyle, "data-testid": "open-at-source-link" },
        React.createElement(Icon, { icon: "external-link" })));
};
export default OpenAtSourceLink;
